import { useQuery } from '@tanstack/react-query'
import { useDebounce } from './useDebounce'
import { searchVendors, type VendorListResponse } from '@/api/vendors'
import { queryKeys } from '@/lib/queryKeys'

interface UseVendorSearchParams {
  query: string
  debounceMs?: number
  limit?: number
  enabled?: boolean
}

/**
 * Hook for searching vendors (by name or code) with debounced query
 * @param params - Search parameters
 */
export function useVendorSearch({
  query,
  debounceMs = 300,
  limit = 20,
  enabled = true,
}: UseVendorSearchParams) {
  const debouncedQuery = useDebounce(query, debounceMs)

  return useQuery<VendorListResponse>({
    queryKey: queryKeys.vendorSearch.byQuery(debouncedQuery),
    queryFn: ({ signal }) =>
      searchVendors(
        {
          q: debouncedQuery,
          limit,
        },
        signal
      ),
    enabled: enabled && debouncedQuery.length >= 1,
    staleTime: 1000 * 60, // Cache for 1 minute
  })
}
